export function InventoryTypeDistributionEchartOp ({ v, data, total }) {
  let option = {
    color: [
      {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 1,
        y2: 1,
        colorStops: [{
          offset: 0, color: '#025EE2' // 0% 处的颜色
        }, {
          offset: 1, color: '#29BAFF' // 100% 处的颜色
        }]
      },
      {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 1,
        y2: 1,
        colorStops: [{
          offset: 0, color: '#B945F5' // 0% 处的颜色
        }, {
          offset: 1, color: '#565BFE' // 100% 处的颜色
        }]
      }, {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 1,
        y2: 1,
        colorStops: [{
          offset: 0, color: '#FF33CB' // 0% 处的颜色
        }, {
          offset: 1, color: '#FA7481' // 100% 处的颜色
        }]
      }, {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 1,
        y2: 1,
        colorStops: [{
          offset: 0, color: '#37B4EE' // 0% 处的颜色
        }, {
          offset: 1, color: '#3AF1C3' // 100% 处的颜色
        }]
      }, {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 1,
        y2: 1,
        colorStops: [{
          offset: 0, color: '#D2ED1B' // 0% 处的颜色
        }, {
          offset: 1, color: '#86F61D' // 100% 处的颜色
        }]
      }
    ],
    title: {
      text: '总数量',
      left: '50%',
      top: '35%',
      subtext: total,
      width: 1200,
      textAlign: 'center',
      textStyle: {
        fontSize: v.fontSizeRem(0.75),
        color: '#FFFFFFCC'
      },
      subtextStyle: {
        fontSize: v.fontSizeRem(1),
        color: '#fff'
      }
    },
    tooltip: {
      trigger: 'item'
    },
    legend: {
      show: false,
      orient: 'horizontal',
      icon: 'circle',
      textStyle: {
        color: 'rgba(255, 255, 255,1)'
      },
      bottom: '10%'
    },
    series: [
      {
        name: 'Access From',
        type: 'pie',
        radius: ['70%', '100%'],
        top: '0%',
        avoidLabelOverlap: false,
        data: [
          // { value: 45.49, name: '关机广告' },
          // { value: 843532.07, name: '开机启动广告' },
          // { value: 120433.18, name: '视频前贴广告' },
          // { value: 13583.63, name: '系统屏保广告' },
          // { value: 2499.97, name: '主页推荐广告' }
          ...data
        ],
        label: {
          show: false,
          position: 'inside',
          color: 'white',
          fontSize: v.fontSizeRem(0.6)
        },
        itemStyle: {
          borderRadius: 2,
          borderColor: '#000',
          borderWidth: 1
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
  }
  return option
}
export function PopularCitiesEchartOp ({ v, data }) {
  let option = {
    color: [],
    grid: {
      left: '5%',
      top: '0%',
      right: '10%',
      bottom: '0%',
      containLabel: true
    },
    xAxis: [{
      type: 'value',
      show: false,
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      axisLine: {
        show: false
      }
    }],
    yAxis: [{
      type: 'category',
      data: [...data.name],
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      }
    }],

    series: [{
      type: 'bar',
      color: {
        type: 'linear',
        x: 1,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, color: 'rgba(202, 55, 255, 1)' // 0% 处的颜色
        }, {
          offset: 1, color: 'rgba(28, 41, 239, 1)' // 100% 处的颜色
        }]
      },
      data: [...data.data],
      barWidth: v.fontSizeRem(1.25),
      showBackground: true,
      backgroundStyle: {
        color: 'rgba(255, 255, 255, 0.2)'
      },
      label: {
        show: false
      }
    }]
  }

  return option
}
export function PopularCitiesNetEchartOp ({ v, data }) {
  let option = {
    color: [],
    grid: {
      left: '5%',
      top: '0%',
      right: '10%',
      bottom: '0%',
      containLabel: true
    },
    xAxis: [{
      type: 'value',
      show: false,
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      axisLine: {
        show: false
      }
    }],
    yAxis: [{
      type: 'category',
      // data: ['建筑房产', '医药保健', '金融理财', '美妆行业', '交通工具类', '零售及服务类', '母婴用品', '网服行业', '酒水饮料行业', '快消日化行业'],
      data: [...data.name],
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      }
    }],

    series: [{
      type: 'bar',
      color: {
        type: 'linear',
        x: 1,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, color: 'rgba(202, 55, 255, 1)' // 0% 处的颜色
        }, {
          offset: 1, color: 'rgba(28, 41, 239, 1)' // 100% 处的颜色
        }]
      },
      data: [...data.data],
      barWidth: v.fontSizeRem(1.25),
      showBackground: true,
      backgroundStyle: {
        color: 'rgba(255, 255, 255, 0.2)'
      },
      label: {
        show: false
      }
    }]
  }

  return option
}
export function PopularGroupLabelEchartOp ({ v, list }) {
  let min = 8
  let max = 40
  let data = []
  // return [{
  //   value: 351372.63,
  //   name: '美妆人群2',
  //   size: 40,
  //   x: 0.1,
  //   y: 0.2
  // }, {
  //   value: 349174.03,
  //   name: '妈妈人群2',
  //   size: 35,
  //   x: 0.12,
  //   y: -0.2
  // }, {
  //   value: 327497.43,
  //   name: '主流文化人群',
  //   size: 33,
  //   x: 0.01,
  //   y: 0.1
  // }, {
  //   value: 305934.04,
  //   name: '精英文化人群',
  //   size: 30,
  //   x: 0.11,
  //   y: 0.1
  // }, {
  //   value: 305934.04,
  //   name: '潮文化人群',
  //   size: 28,
  //   x: 0,
  //   y: -0.1
  // }, {
  //   value: 300971.05,
  //   name: '通俗文化人群',
  //   size: 25,
  //   x: 0.07,
  //   y: -0.05
  // }, {
  //   value: 174491.26,
  //   name: '乐活文化人群',
  //   size: 22,
  //   x: 0.1,
  //   y: 0.01
  // }, {
  //   value: 167349.11,
  //   name: '文艺人群',
  //   size: 22,
  //   x: -0.02,
  //   y: 0.17
  // }, {
  //   value: 153315.29,
  //   name: '二次元按人群',
  //   size: 22,
  //   x: -0,
  //   y: 0
  // }]

  // 获取比例尺,domain: 输入域，range 输出域
  function getScale ([d1, d2], [r1, r2]) {
    return function (val) {
      return (val - d1) / (d2 - d1) * (r2 - r1) + r1
    }
  }

  // value 对应的比例尺
  // 泡泡大小
  let scale = getScale([min, max], [2, 80])
  // label字体大小
  let scaleFontSize = getScale([min, max], [20, 38])
  // 对应类别categories根据value 值对应5种
  let scaleCategory = getScale([5, 30], [0, 5])
  let positionXY = [
    { x: 0.1,
      y: 0.2 },
    { x: 0.12,
      y: -0.2 },
    { x: 0.01,
      y: 0.1 },
    { x: 0.14,
      y: 0.1 },
    { x: 0,
      y: -0.1 },
    { x: 0.09,
      y: -0.12 },
    { x: 0.1,
      y: 0.01 },
    { x: -0.05,
      y: 0.17 },
    { x: -0.03,
      y: 0 },
    { x: 0.06, y: -0.25 }
  ]
  data = list.map((item, index) => {
    let {
      value, size
    } = item
    let zf = Math.random() > 0.5 ? Math.random() * 1 : Math.random() * -1
    return Object.assign(item, {
      symbolSize: scale(size),
      // category: Math.floor(scaleCategory(size)),
      category: Math.floor(Math.random() * 5),
      label: {
        // fontSize: parseInt(scaleFontSize(value))
        fontSize: v.fontSizeRem(scaleFontSize(size) * 0.015)
      },
      ...positionXY[index]
    })
  })
  let option = {
    series: [{
      type: 'graph',
      layout: 'none',
      legendHoverLink: false,
      force: {
        repulsion: 80,
        edgeLength: 80
      },
      categories: [
        {
          itemStyle: {
            color: {
              type: 'radial',
              x: 0.3,
              y: 0.5,
              r: 0.7,
              colorStops: [{
                offset: 0, color: 'rgba(250, 168, 58, 1)' // 0% 处的颜色
              }, {
                offset: 1, color: 'rgba(244, 138, 27, 1)' // 100% 处的颜色
              }]
            }
          }
        },
        {
          itemStyle: {
            color: {
              type: 'radial',
              x: 0.3,
              y: 0.5,
              r: 0.7,
              colorStops: [{
                offset: 0, color: 'rgba(147, 58, 250, 1)' // 0% 处的颜色
              }, {
                offset: 1, color: 'rgba(97, 14, 208, 1)' // 100% 处的颜色
              }]
            }
          }
        },
        {
          itemStyle: {
            color: {
              type: 'radial',
              x: 0.3,
              y: 0.5,
              r: 0.7,
              colorStops: [{
                offset: 0, color: 'rgba(58, 141, 250, 1)' // 0% 处的颜色
              }, {
                offset: 1, color: 'rgba(27, 84, 244, 1)' // 100% 处的颜色
              }]
            }
          }
        },
        {
          itemStyle: {
            color: {
              type: 'radial',
              x: 0.3,
              y: 0.5,
              r: 0.7,
              colorStops: [{
                offset: 0, color: 'rgba(255, 124, 202, 1)' // 0% 处的颜色
              }, {
                offset: 1, color: 'rgba(241, 16, 145, 1)' // 100% 处的颜色
              }]
            }
          }
        },
        {
          itemStyle: {
            color: {
              type: 'radial',
              x: 0.3,
              y: 0.5,
              r: 0.7,
              colorStops: [{
                offset: 0, color: 'rgba(70, 255, 189, 1)' // 0% 处的颜色
              }, {
                offset: 1, color: 'rgba(32, 207, 124, 1)' // 100% 处的颜色
              }]
            }
          }
        }
      ],
      label: {
        show: true,
        textStyle: {
          color: 'rgba(255, 255, 255,1)'
        }
      },
      data
    }]
  }
  return option
}

function ItemSevenContentEchartOpDefalut ({ v }) {
  let option = {
    title: {
      text: '',
      textStyle: {
        color: 'rgba(255, 255, 255, 1)',
        fontSize: v.fontSizeRem(0.75)
      },
      left: 'center'
    },
    grid: {
      left: '0%',
      top: '15%',
      right: '15%',
      bottom: '0%',
      containLabel: true
    },
    xAxis: {
      name: '月',
      type: 'category',
      boundaryGap: false,
      data: ['2021-12', '2022-01', '2022-02'],
      axisLabel: {
        color: 'rgba(255, 255, 255, 1)'
      },
      nameTextStyle: {
        color: 'rgba(255, 255, 255, 1)'
      }

    },
    yAxis: [
      {
        type: 'value',
        splitNumber: 5,
        axisLabel: {
          color: 'rgba(255, 255, 255, 1)'
        },
        splitLine: {
          show: false
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: 'rgba(75, 133, 255, 1)'
          }
        }
      }
    ],
    series: [
      {
        data: [820, 932, 901, 934, 1290, 1330, 1320],
        type: 'line',
        smooth: true,
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 1,
            x2: 0,
            y2: 0,
            colorStops: [{
              offset: 0, color: 'rgba(40, 92, 240, 0)' // 0% 处的颜色
            }, {
              offset: 1, color: 'rgba(40, 92, 240, 1)' // 100% 处的颜色
            }]
          }
        },
        yAxisIndex: 0
      }
    ]
  }
  return option
}

export function ECommerceIndustryEchartOp ({ v, data }) {
  let op = ItemSevenContentEchartOpDefalut({ v })
  op.title.text = data.title
  op.series[0].data = [...data.data]
  return op
}
export function FoodIndustryEchartOp ({ v, data }) {
  let op = ItemSevenContentEchartOpDefalut({ v })
  op.title.text = data.title
  op.series[0].data = [...data.data]
  return op
}
export function AutomobileIndustryEchartOp ({ v, data }) {
  let op = ItemSevenContentEchartOpDefalut({ v })
  op.title.text = data.title
  op.series[0].data = [...data.data]
  return op
}

export function AnalysisFamilyAudiencePreferenceEchartOp ({ v, data }) {
  let option = {
    title: {
      text: '家庭受众偏好分析',
      left: '38%',
      textStyle: {
        color: 'white',
        fontSize: v.fontSizeRem(0.75)
      }
    },
    grid: {
      left: '0%',
      top: '23%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    xAxis: [{
      type: 'category',
      data: [...data.name],
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)',
        rotate: 25
        // fontSize: v.fontSizeRem(0.75)
      },
      nameTextStyle: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      }
    }],
    yAxis: [{
      name: '偏好指数',
      type: 'value',
      show: true,
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      axisLine: {
        show: false
      },
      splitLine: {
        show: false
      },
      nameTextStyle: {
        color: 'rgba(255, 255, 255, .8)'
      }
    }],

    series: [{
      type: 'bar',
      color: {
        type: 'linear',
        x: 0,
        y: 1,
        x2: 0,
        y2: 0,
        colorStops: [{
          offset: 0, color: '#37B3F0FF' // 0% 处的颜色
        }, {
          offset: 1, color: '#40ECC4FF' // 100% 处的颜色
        }]
      },
      data: [...data.data],
      barWidth: v.fontSizeRem(0.75),
      itemStyle: {
        // borderRadius: 50
      },
      showBackground: true,
      backgroundStyle: {
        // borderRadius: 50,
        color: '#2F3438'
      },
      label: {
        normal: {
          show: false
        }
      }
    }]
  }
  return option
}
export function InteractiveBehaviorAnalysisEchartOp ({ v, data }) {
  let option = {
    title: {
      text: '交互行为分析',
      left: '35%',
      textStyle: {
        color: 'white',
        fontSize: v.fontSizeRem(0.75)
      }
    },
    grid: {
      left: '10%',
      top: '23%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    xAxis: [{
      type: 'category',
      data: [...data.name],
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)',
        rotate: 25
        // fontSize: v.fontSizeRem(0.75)
      },

      nameTextStyle: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      }
    }],
    yAxis: [{
      name: '交互指数(%)',
      type: 'value',
      show: true,
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      axisLine: {
        show: false
      },
      splitLine: {
        show: false
      },
      nameTextStyle: {
        color: 'rgba(255, 255, 255, .8)'
      }
    }],
    series: [{
      type: 'bar',
      color: {
        type: 'linear',
        x: 0,
        y: 1,
        x2: 0,
        y2: 0,
        colorStops: [{
          offset: 0, color: '#412DD0FF' // 0% 处的颜色
        }, {
          offset: 1, color: '#2BD6F9FF' // 100% 处的颜色
        }]
      },
      data: [...data.data],
      barWidth: v.fontSizeRem(0.75),
      itemStyle: {
        // borderRadius: 50
      },
      showBackground: true,
      backgroundStyle: {
        // borderRadius: 50,
        color: '#2F3438'
      },
      label: {
        normal: {
          show: false
        }
      }
    }]
  }
  return option
}
